window.addEventListener('DOMContentLoaded', function() {
        const video = document.querySelector('.landing-page-video');
        
        if (video) {
          // Try to play the video programmatically
          const playPromise = video.play();
    
          if (playPromise !== undefined) {
            playPromise.catch(function(error) {
              // Autoplay was blocked, so replace with white screen
              const whiteScreen = document.createElement('div');
              whiteScreen.style.width = video.offsetWidth + 'px';
              whiteScreen.style.height = video.offsetHeight + 'px';
              whiteScreen.style.backgroundColor = '#000000';
    
              video.parentNode.replaceChild(whiteScreen, video);
            });
          }
        }
      });